import { render } from "./index.vue?vue&type=template&id=49bd182e&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=49bd182e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-49bd182e"

export default script